import { z } from "zod";

export type SurveyOption = z.infer<typeof SurveyOptionSchema>;
export const SurveyOptionSchema = z.object({
  id: z.number(),
  content_type: z.string(),
  label: z.string(),
  score: z.number(),
  url: z.string(),
});
